import request from "@/utils/request";

/**
 * 用户相关 API
 */

/** 并发去重：布局 + 详情 + 侧栏等同时拉 current 时只发一次 HTTP */
let inflightCurrentUser = null;

/**
 * 获取当前登录用户信息
 * @returns {Promise}
 */
export function getCurrentUser() {
  if (!inflightCurrentUser) {
    inflightCurrentUser = request.get("/api/user/current").finally(() => {
      inflightCurrentUser = null;
    });
  }
  return inflightCurrentUser;
}

/**
 * 更新用户信息（基础资料：昵称、邮箱、性别、手机、个人简介等）
 * @param {Object} userData 用户数据
 * @returns {Promise}
 */
export function updateUser(userData) {
  return request.put("/api/user", userData);
}

/**
 * 单独更新头像
 * @param {string} avatarUrl 头像 URL
 * @returns {Promise}
 */
export function updateAvatar(avatarUrl) {
  return request.put("/api/user/avatar", { avatar: avatarUrl });
}

/**
 * 绑定邮箱。首次绑定时需传 password，绑定后可用邮箱+密码登录；换绑时可不传 password。
 * @param {string} email 邮箱地址
 * @param {string} code 验证码
 * @param {string} [password] 登录密码（至少8位，换绑时不传）
 * @returns {Promise}
 */
export function bindEmail(email, code, password) {
  return request.post("/api/user/bindEmail", {
    email: email,
    code: code,
    password: password,
  });
}

/**
 * 获取用户统计数据
 * @returns {Promise}
 */
export function getStat() {
  return request.get("/api/user/stat");
}

/**
 * 获取指定用户的统计信息
 * @param {number} userId 用户ID
 * @returns {Promise}
 */
export function getUserStat(userId) {
  return request.get(`/api/user/stat/${userId}`);
}
